// extracted by mini-css-extract-plugin
export var box = "Box-module--box--fNE5w";
export var boxPrimary = "Box-module--box--primary--3zJRj";